import { useCallback, useMemo, useState } from "react";

const LocalStorageKey = "calauto-google-access-token";

export function useGoogleAccessToken() {
  const [accessToken, setAccessToken] = useState<string | null>(() => {
    const accessToken = localStorage.getItem(LocalStorageKey);
    return accessToken ?? null;
  });

  const handleSetAccessToken = useCallback(
    (newAccessToken: string | null) => {
      if (newAccessToken) {
        setAccessToken(newAccessToken);
        localStorage.setItem(LocalStorageKey, newAccessToken);
      } else {
        setAccessToken(null);
        localStorage.removeItem(LocalStorageKey);
      }
    },
    [setAccessToken]
  );

  return useMemo(() => {
    return { accessToken, setAccessToken: handleSetAccessToken };
  }, [accessToken, handleSetAccessToken]);
}
